"use strict";
exports.__esModule = true;
exports.AccessoryInventory = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var AccessoryInventory = /** @class */ (function () {
    function AccessoryInventory() {
    }
    AccessoryInventory.getManyAccessoryInventorysByAccessoryModelConfiguration = function (accessoryInventorys, accessoryReference) {
        return accessoryInventorys.filter(function (pi) { return core_designer_domain_1.AccessoryReference.identical(pi.accessoryReference, accessoryReference); });
    };
    AccessoryInventory.getOneAccessoryInventorysByAccessoryModelConfiguration = function (accessoryInventorys, accessoryReference) {
        var result = AccessoryInventory.getManyAccessoryInventorysByAccessoryModelConfiguration(accessoryInventorys, accessoryReference);
        if (result.length === 0) {
            return undefined;
        }
        if (result.length > 1)
            throw new core_common_domain_1.Exception("Trying to get one Accessory inventory item but found more than one that match the search criteria.");
        return result[0];
    };
    return AccessoryInventory;
}());
exports.AccessoryInventory = AccessoryInventory;
